import "react-datepicker/dist/react-datepicker.css";
import "../src/colors/colors.css";
import App from "./app";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "styled-components";
import theme from "./app/utils/theme";
import { initSessionEndedPageshowGuard } from "./app/utils/sessionEnded";

initSessionEndedPageshowGuard();

// StrictMode left off for now: MSAL is on v5 (React 18–compatible). Re-enable
// <React.StrictMode> in a follow-up once auth redirect flows are regression-tested.
createRoot(document.getElementById("root")).render(
  <MuiThemeProvider theme={theme}>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </MuiThemeProvider>,
);
